/*****************************************************************************/
/*  File Name: index.js                                                      */
/*  Date:      June 21, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the base ROI dashboard page that will serve           */
/*             the calculator functionality                                  */
/*****************************************************************************/

import React /* useState,*/, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import * as ROUTES from '../../constants/routes';
import { Navigate } from 'react-router-dom';
//import Grid from '@mui/material/Grid';
import { useUserContext } from '../../context/userContext';

import Header from '../Header';
import styles from './styles/roi.module.scss';

import { useROIContext } from '../../context/roiContext';
import { useParams } from 'react-router-dom';

import LeftBar from './leftBar';
import BottomHalf from './bottomHalf';
import TimeRangeBar from './timeRangeBar';
import TimeRangeCalculations from './timeRangeCalculations';
import UpgradeRow from './upgradeRow';
import AnnualCalculations from './annualCalculations';
import AnnualProfitDiffBar from './annualProfitDiffBar';
import TipCountHeader from './tipCountHeader';
import TaxCalculations from './taxCalculations';
import FreeTipOverview from './freeTipOverview';
import FreeTipImpact from './freeTipImpact';
import TreatmentTable from './treatmentTable';
import ChartBlock from './chartBlock';
import * as MODES from '../../constants/modes';
import ConsumerChartBlock from './consumerChartBlock';
import ConsumerCountHeader from './consumerCountHeader';
import ConsumerTimeRangeCalculations from './consumerTimeRangeCalculations';
import ConsumerAnnualCalculations from './consumerAnnualCalculations';
import Footer from '../Footer';
import UpgradeCountHeader from './upgradeCountHeader';
import PdfModule from './pdfModule';

//Analytics
import { analytics } from '../../firebase/firebase';
import { logEvent } from 'firebase/analytics';

function ROI({ t }) {
  //Load all of the default component varaibles
  const [pageLoad, setPageLoad] = useState(true);
  const { id } = useParams();
  const { user } = useUserContext();
  const { loadROI, roiLoading, drawerOpen, roiID, roiMode, totalFreeTipCount } = useROIContext();
  const hasFreeTips = totalFreeTipCount() > 0;

  useEffect(() => {
    if (id && user && roiLoading && pageLoad) {
      //console.log('is my use effect firing???');
      loadROI(id);
    }
    return () => {
      setPageLoad(false);
    };
  }, [id, roiLoading, user, loadROI, pageLoad]);

  //Firebase Analytics does not track time spent on a page
  // This is a manual way to do so 
  useEffect(() => {
      const startTime = Date.now();

      return () => {
        const timeSpentSeconds = Math.round((Date.now() - startTime) /1000/60); // ms -> min
        logEvent(analytics, 'page_time_spent', {
          page: 'ROI_page',
          duration_seconds: timeSpentSeconds,
        });
      };
    }, []);

  if (!user) return <Navigate to={ROUTES.LOGIN} />;

  if (!roiID) return <Navigate to={ROUTES.LANDING} />;

  //check role if = clinic role
  //nav to unique url based on user clinicID

  //console.log('this is my roiloading --> ', roiLoading);

  //console.log('this is my systems ----->', systems);

  //console.log('this is my pageLoading -----> ', pageLoad);
  //console.log('am i getting loading ', roiLoading);

  return (
    <>
      <Header />
      {!roiLoading ? (
        <div className={styles.container}>
          <div className={`${styles.topHalf}  ${roiMode === MODES.upgrade ? styles.upgrade : ''} ${!drawerOpen ? styles.formClosed : ''}`}>
            <LeftBar />
            <div className={styles.roiInformation}>

              {
                roiMode === MODES.consumer ?
                  <>
                  <div className={`${styles.topHalf} ${styles.consumerLayout}`}>
                    {/*This is the left hand side */}
                    <div className={styles.chartHalf}>
                      <TipCountHeader />
                      <TimeRangeBar />
                      <div className={styles.consumerGroup} >
                        <ChartBlock />
                        <TimeRangeCalculations />
                        <AnnualCalculations />
                      </div>
                    </div>
                    {/*This is the right hand side */}
                    <div className={styles.chartHalf}>
                      <ConsumerCountHeader />
                      <ConsumerChartBlock />
                      <ConsumerTimeRangeCalculations />
                      <ConsumerAnnualCalculations />
                    </div>
                  </div>
                  <FreeTipImpact />
                  </>
                  : null
              }



              {roiMode === MODES.capital ?
                <div className={`${styles.topHalf} ${styles.capitalLayout}`}>
                  {/*This is the left hand side */}
                  <div className={styles.chartHalf}>
                    <TipCountHeader />
                    <TimeRangeBar />
                    <div className={styles.capitalGroup} >
                      <TimeRangeCalculations />
                      <div className={styles.divider}></div>
                      <AnnualCalculations />
                      <div className={styles.divider}></div>
                      <TaxCalculations />
                      <FreeTipOverview />
                    </ div> </div>
                  {/*This is the right hand side */}
                  <div className={styles.tableHalf}>
                    <TreatmentTable />
                  </div>
                </div>
                : null
              }

              {roiMode === MODES.upgrade ?
              <>
                <div className={`${styles.topHalf} ${styles.updateGradeGroup}`}>
                  <div className={styles.header}>
                    {/*This is the left hand side */}
                    <div className={`${styles.chartHalf} ${styles.header}`}>
                      <TipCountHeader />
                    </div>
                    {/*This is the right hand side */}
                    <div className={`${styles.chartHalf} ${styles.right} ${styles.header}`}>
                      <UpgradeCountHeader />
                    </div>
                  </div>
                  <div className={styles.timeRangeBar}>
                    <TimeRangeBar />
                    <UpgradeRow />
                  </div>
                  <div className={styles.bottomValues} >
                    {/*This is the left hand side */}
                    <div className={`${styles.chartHalf} `}>
                      <div className={styles.upgradeGroup} >
                        <TimeRangeCalculations />
                        <div className={styles.divider}></div>
                        <AnnualCalculations />
                      </div>
                    </div>
                    {/*This is the right hand side */}
                    <div className={`${styles.chartHalf} ${styles.right}`}>
                      <div className={`${styles.upgradeGroup} ${styles.right}`} >
                        <ConsumerTimeRangeCalculations />
                        <div className={styles.divider}></div>
                        <ConsumerAnnualCalculations />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${styles.upgradeSummaryRow} ${!hasFreeTips ? styles.noFreeTips : ''}`}>
                  {hasFreeTips ? (
                    <div className={styles.upgradeSummaryOverview}>
                      <FreeTipOverview />
                    </div>
                  ) : null}
                  <div className={styles.upgradeSummaryDifference}>
                    <AnnualProfitDiffBar compact={hasFreeTips} />
                  </div>
                </div>
                </>
              :null}
            </div>
            <div className={styles.roiSection}></div>
          </div>
          
          <PdfModule />
          <BottomHalf />
          <Footer />
        </div>
      ) : (
        'LOADING GRAPHIC'
      )}
    </>
  );
}

export default withTranslation()(ROI);
